import { colors } from '../../constants';
const MuiMenu = {
  paper: {
    '.OriSelectPaper&': {
      border: `1px solid ${colors.oriGrey[300]}`,
      borderRadius: 5
    }
  }
};
export default MuiMenu;